//src/services/adminCoupons.api.js
import { adminApiRequest } from "./adminApi";

export const getAdminCoupons = () =>
  adminApiRequest("/admin/coupons");

export const createAdminCoupon = (data) =>
  adminApiRequest("/admin/coupons", {
    method: "POST",
    body: JSON.stringify(data),
  });

export const updateAdminCoupon = (id, data) =>
  adminApiRequest(`/admin/coupons/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });

export const deleteAdminCoupon = (id) =>
  adminApiRequest(`/admin/coupons/${id}`, {
    method: "DELETE",
  });

export const getActiveCouponsCount = () =>
  adminApiRequest("/admin/coupons/count/active");

  export const activateAllCoupons = () =>
  adminApiRequest("/admin/coupons/activate-all", {
    method: "PUT",
  });

export const deactivateAllCoupons = () =>
  adminApiRequest("/admin/coupons/deactivate-all", {
    method: "PUT",
  });

  export const getAdminCouponById = (id) => {
  return adminApiRequest(`/admin/coupons/${id}`);
};